/**
 * メインスクリプトファイル
 * サイトのフロントエンド機能を管理します
 */

// IIFE（即座実行関数式）を使用してスコープを分離
(function() {
	'use strict';

	// フロントエンドの初期化コード
	const init = () => {
		// ここにサイトの初期化コードを書く
		initMoreMenu();
		initScrollTopIntersection();
	};

	// DOMの読み込みが完了したら初期化を実行
	document.addEventListener('DOMContentLoaded', init);

	const toggleMenu = () => {
		const hamburger = document.getElementById('js-hamburger');
		const closeNav = document.getElementById('js-close-nav');

		if (!hamburger) return;

		hamburger.addEventListener('click', () => {
			const body = document.body;
			const isOpen = body.classList.contains('is-nav-open');
			
			if (isOpen) {
				// メニューを閉じる
				closeMenu();
			} else {
				// メニューを開く
				openMenu();
			}
		});

		// オーバーレイをクリックしてナビゲーションを閉じる
		if (closeNav) {
			closeNav.addEventListener('click', () => {
				closeMenu();
			});
		}
	};

	// メニューを開く
	const openMenu = () => {
		const body = document.body;
		body.classList.add('is-nav-open');
	};

	// メニューを閉じる
	const closeMenu = () => {
		const body = document.body;
		body.classList.remove('is-nav-open');
	}

	/**
	 * スクロールトップボタンの色をフッターとの交差で切り替え
	 */
	const initScrollTopIntersection = () => {
		const scrollTopButton = document.querySelector('.l-footer__scroll-top');
		const footer = document.querySelector('.l-footer');
		
		if (!scrollTopButton || !footer) return;
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					scrollTopButton.classList.add('is-on-footer');
				} else {
					scrollTopButton.classList.remove('is-on-footer');
				}
			});
		}, {
			threshold: 0.1
		});
		
		observer.observe(footer);
	};

	/**
	 * メニューの「もっと見る」機能を初期化
	 */
	const initMoreMenu = () => {
	const moreButton = document.getElementById('js-more-button');
	const moreMenu = document.getElementById('js-more-menu');
	const moreMenuItem = document.querySelector('.l-header__menu-item--more');
	const mainMenu = document.querySelector('.l-header__menu');
	
	if (!moreButton || !moreMenu || !moreMenuItem || !mainMenu) return;
	
	// 画面サイズに応じてメニューの表示を更新
	function updateMenuDisplay() {
		const screenWidth = window.innerWidth;
		const allMenuItems = Array.from(mainMenu.children);
		
		// 1700px以上では「もっと見る」を非表示
		if (screenWidth >= 1700) {
			moreMenuItem.parentElement.style.display = 'none';
			return;
		}
		
		// 表示可能なメニュー数を計算
		let visibleCount = 5; // デフォルト（768px以上）
		if (screenWidth >= 1600) visibleCount = 10;
		else if (screenWidth >= 1500) visibleCount = 9;
		else if (screenWidth >= 1400) visibleCount = 8;
		else if (screenWidth >= 1300) visibleCount = 7;
		else if (screenWidth >= 1200) visibleCount = 6;
		
		// 「もっと見る」の表示制御
		const totalItems = allMenuItems.length;
		if (totalItems > visibleCount) {
			moreMenuItem.parentElement.style.display = 'flex';
			
			// 「もっと見る」メニューの内容を更新
			updateMoreMenuContent(visibleCount);
		} else {
			moreMenuItem.parentElement.style.display = 'none';
		}
	}
	
	// 「もっと見る」メニューの内容を更新
	function updateMoreMenuContent(visibleCount) {
		const allMenuItems = Array.from(mainMenu.children);
		const hiddenItems = allMenuItems.slice(visibleCount);
		
		// 既存の「もっと見る」メニューをクリア
		moreMenu.innerHTML = '';
		
		// 隠れたアイテムを「もっと見る」メニューに追加
		hiddenItems.forEach(item => {
			const link = item.querySelector('a');
			if (link) {
				const li = document.createElement('li');
				li.className = 'menu-item';
				const a = document.createElement('a');
				a.href = link.href;
				a.textContent = link.textContent;
				li.appendChild(a);
				moreMenu.appendChild(li);
			}
		});
	}
	
	// 初期化時とリサイズ時にメニュー表示を更新
	updateMenuDisplay();
	
	// ResizeObserverを使ってナビゲーション要素の変更を監視
	if (window.ResizeObserver) {
		const resizeObserver = new ResizeObserver(() => {
			updateMenuDisplay();
		});
		
		// ナビゲーション要素を監視
		const navElement = document.querySelector('.l-header__nav');
		if (navElement) {
			resizeObserver.observe(navElement);
		}
	} else {
		// ResizeObserverがサポートされていない場合のフォールバック
		window.addEventListener('resize', updateMenuDisplay);
	}
	
	// クリックイベントを追加
	moreButton.addEventListener('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		
		const isOpen = moreButton.getAttribute('aria-expanded') === 'true';
		
		if (isOpen) {
			closeMoreMenu();
		} else {
			openMoreMenu();
		}
	});
	
	// 外側クリックで閉じる
	document.addEventListener('click', (e) => {
		if (!moreMenuItem.contains(e.target)) {
			closeMoreMenu();
		}
	});
	
	// ESCキーで閉じる
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeMoreMenu();
		}
	});
	
	function openMoreMenu() {
		moreButton.setAttribute('aria-expanded', 'true');
		moreMenuItem.classList.add('is-open');
	}
	
	function closeMoreMenu() {
		moreButton.setAttribute('aria-expanded', 'false');
		moreMenuItem.classList.remove('is-open');
	}
	};

	// 初期化実行
	toggleMenu();

	const toggleTableOfContents = () => {
		const btn = document.querySelector('.ez-toc-toggle');
		const toc = document.getElementById('ez-toc-container');

		if (!btn || !toc) return;

		toc.classList.add('has-no-jquery');

		btn.addEventListener('click', (e) => {
			e.preventDefault();
			toc.classList.toggle('toc_close');
		});
	};

	if (typeof jQuery !== "function") {
		toggleTableOfContents();
	}
	

})(); // IIFE終了